import { OmegaComponent, dates } from "@omegagrid/core";
import { getLocale, msg } from "@omegagrid/localize";
import { AccessRight } from "@reporting/rp-types/users";
import { css, html } from "lit";
import { customElement, property } from "lit/decorators.js";
import { choose } from "lit/directives/choose.js";
import rp from "@reporting/rp-app-host";
import { CellModel } from "@omegagrid/grid";

const iconMap: Record<string, string> = {
	'R': 'users',
	'A': 'building',
	'G': 'buildings'
}

@customElement('rp-access-right-detail')
export class AccessRightDetail extends OmegaComponent {

	static styles = [OmegaComponent.styles, css`
		table {
			border-collapse: collapse;
			width: 100%;
			font-size: 10px;
		}
		th, td {
			border: 1px solid var(--og-colortype-yellow-border-color);
			padding: 2px;
		}
		th {
			text-align: left;
			width: 100px;
		}
		a { color: red !important; }
		a:hover { text-decoration: underline; cursor: pointer; }
	`];

	@property({type: Object})
	cell: CellModel;

	get right(): AccessRight | null {
		const rights = this.cell ? this.cell.getProperty('rights') as AccessRight[] : null;
		return rights ? rights[0] : null;
	}

	_onSourceClick = () => {
		switch (this.right.source) {
			case 'A':
				rp.host.open(`users-userAccessContainer-a-${this.right.id_source}`, {title: this.right.source_name});
				break;
			case 'R':
				rp.host.open(`users-userAccessContainer-r-${this.right.id_source}`, {title: this.right.source_name});
				break;
			case 'G':
				if (this.right.user_name) {
					rp.host.open(`users-userAccessContainer-u-${this.right.user_name}`, {title: this.right.login_name});
				} else if (this.right.id_access_role) {
					rp.host.open(`users-userAccessContainer-r-${this.right.id_access_role}`, {title: this.right.role});
				}
				break;
		}
	}

	get inherited() {
		const right = this.right;
		if (!right) return false;
		if (this.cell.row.getProperty('rowType') == 'group') return false;
		return right.id_source && (right.source != 'A' || right.id_source != right.accounting);
	}

	render = () => this.right ? html`
		<table>
			${this.inherited ? html`
				<tr>
					<th>${msg('Inherited from')}</th>
					<td>
						<a @click="${this._onSourceClick}">
							<span>#${this.right.id_source} ${this.right.source_name}</span>
						</a>
						<span>(<og-icon .icon="${iconMap[this.right.source]}"></og-icon> ${choose(this.right.source, [
							['A', () => html`<span>${msg('company')}</span>`],
							['R', () => html`<span>${msg('user group')}</span>`],
							['G', () => html`<span>${msg('group')}</span>`]
						])})</span>
					</td>
				</tr>
			` : ''}

			<tr>
				<th>${msg('Granted by')}</th>
				<td>
					${this.right.who_created ? html`
						${this.right.who_created}
					` : '-'}
				</td>
			</tr>

			<tr>
				<th>${msg('Granted at')}</th>
				<td>
				${this.right.date_created ? html`
					${dates.format(this.right.date_created, dates.getDateFormat({withTime: true}))}
				` : '-'}
				</td>
			</tr>
		</table>
	` : '';

}
